import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormElementModel } from '@app/clinical-feedback/clinical-feedback.model';

@Component({
    selector: 'app-validation-error',
    templateUrl: './validation-error.component.html',
    styleUrls: ['./validation-error.component.scss'],
    viewProviders: []
})
export class ValidationErrorComponent {
    @Input() control!: AbstractControl;
    @Input() formElementModel!: FormElementModel;

    get validationErrorLabel() {
        return this.formElementModel.placeholder ? this.formElementModel.placeholder : this.formElementModel.fieldName;
    }
}
